import { render, staticRenderFns } from "./components-create.vue?vue&type=template&id=a4ad5bde"
import script from "./components-create.vue?vue&type=script&lang=js"
export * from "./components-create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports